type Permutation<T extends Record<string, unknown>> = {
    [K in keyof T]: T[K] extends readonly unknown[] ? T[K][number] : T[K];
};

type PartialPermutation<T extends Record<string, unknown>> = Partial<Permutation<T>>;

export const generatePermutations = <T extends Record<string, unknown>>(input: T): Permutation<T>[] => {
    const keys = Object.keys(input) as (keyof T)[];

    let result: PartialPermutation<T>[] = [{}];

    result = keys.reduce((acc, key) => {
        const values = Array.isArray(input[key]) ? input[key] : [input[key]];

        return acc.flatMap((obj) =>
            values.map((value) => ({
                ...obj,
                [key]: value,
            }))
        );
    }, result);

    return result as Permutation<T>[];
};
